var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup",style:([_vm.boxPositon])},[(_vm.infoData.id !== -1)?_c('div',{staticClass:"container"},[_vm._v(" 详情"+_vm._s(_vm.infoData)+" ")]):_c('div',{staticClass:"container"},[_c('AddTask',{attrs:{"infoData":_vm.infoData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }